function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}"));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M102.88,124.89a13.23,13.23,0,0,0-2.53-1c0,4.74-.11,13.52-.11,13.52-3.44-.55-5.78.32-9.73,3.25-6.82-3.56-10.43-3.13-10.43-3.13V123.8A9.84,9.84,0,0,0,76.87,125v15.34a51.93,51.93,0,0,1,13.5.7c4-1.65,8.88-.71,12.51-.33C103,135.45,102.88,124.89,102.88,124.89Z",
  transform: "translate(-76.42 -120.54)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M90.51,140.43c3.95-2.94,6.29-3.57,9.73-3,0,0,.08-8.78.11-13.52,0-1.37,0-2.4,0-2.8-2.57-.44-6.15.6-10.11,3Z",
  transform: "translate(-76.42 -120.54)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M90.27,140.43l0-16.39c-4.43-2.21-6.84-2.88-10.16-2.91v16.4S83.45,136.86,90.27,140.43Z",
  transform: "translate(-76.42 -120.54)"
});
var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "cls-2",
  x1: 13.98,
  y1: 20.25,
  x2: 13.82,
  y2: 3.5
});
function SvgBranchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.94 20.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Branch-deselected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchIcon);
export default __webpack_public_path__ + "static/media/BranchIcon.47667e8f.svg";
export { ForwardRef as ReactComponent };